import {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  calcularResumoFinanceiro,
  calcularResumoPorOrigem,
  criarMovimentoManual,
  fecharCaixaDia,
  loadMovimentosPeriodo,
  loadFechamentosPeriodo,
  editarMovimentoManual,
  estornarMovimentoManual,
  reabrirCaixaDia,
} from "./financeiro.service";

import type {
  FechamentoCaixa,
  FormaPagamentoFinanceiro,
  MovimentoCaixa,
  TipoMovimento,
} from "./financeiro.service";

import "./Financeiro.css";


function todayISO() {
  const now =
    new Date();

  const year =
    now.getFullYear();

  const month =
    String(
      now.getMonth() + 1,
    ).padStart(
      2,
      "0",
    );

  const day =
    String(
      now.getDate(),
    ).padStart(
      2,
      "0",
    );

  return `${year}-${month}-${day}`;
}


function firstDayOfMonthISO() {
  const now =
    new Date();

  return `${now.getFullYear()}-${String(
    now.getMonth() + 1,
  ).padStart(
    2,
    "0",
  )}-01`;
}


function formatBRL(
  value: number,
) {
  return new Intl.NumberFormat(
    "pt-BR",
    {
      style: "currency",
      currency: "BRL",
    },
  ).format(value);
}


function formatDateBR(
  value: string,
) {
  const [
    year,
    month,
    day,
  ] =
    value.split("-");

  return `${day}/${month}/${year}`;
}


function formatFormaPagamento(
  value:
    FormaPagamentoFinanceiro | null,
) {
  switch (value) {
    case "pix":
      return "Pix";

    case "dinheiro":
      return "Dinheiro";

    case "debito":
      return "Débito";

    case "credito":
      return "Crédito";

    default:
      return "Não informada";
  }
}

function previousEquivalentRange(
  inicio: string,
  fim: string,
) {
  const start =
    new Date(
      `${inicio}T00:00:00`,
    );

  const end =
    new Date(
      `${fim}T00:00:00`,
    );

  const durationMs =
    end.getTime() -
    start.getTime();

  const previousEnd =
    new Date(
      start.getTime() -
      24 *
        60 *
        60 *
        1000,
    );

  const previousStart =
    new Date(
      previousEnd.getTime() -
      durationMs,
    );

  function toISO(
    value: Date,
  ) {
    const year =
      value.getFullYear();

    const month =
      String(
        value.getMonth() + 1,
      ).padStart(
        2,
        "0",
      );

    const day =
      String(
        value.getDate(),
      ).padStart(
        2,
        "0",
      );

    return `${year}-${month}-${day}`;
  }

  return {
    inicio:
      toISO(
        previousStart,
      ),

    fim:
      toISO(
        previousEnd,
      ),
  };
}


function formatOrigem(
  value: string | null,
) {
  switch (value) {
    case "comanda":
      return "Comanda";

    case "quadra":
      return "Quadra";

    case "aula_pacote":
      return "Pacote de aulas";

    case "aula_avulsa":
      return "Aula avulsa";

    case "entrada_manual":
      return "Entrada manual";

    case "despesa_manual":
      return "Despesa manual";

      case "estorno_manual":
  return "Estorno manual";

    default:
      return value ||
        "Não informada";
  }
}


export default function Financeiro() {
  const [
    dataInicio,
    setDataInicio,
  ] =
    useState(
      firstDayOfMonthISO(),
    );

    const [
  relatorioOpen,
  setRelatorioOpen,
] =
  useState(false);

    const [
  fechamentoReabrindo,
  setFechamentoReabrindo,
] =
  useState<FechamentoCaixa | null>(
    null,
  );

  const [
  movimentosMesAnterior,
  setMovimentosMesAnterior,
] =
  useState<
    MovimentoCaixa[]
  >([]);


const [
  motivoReabertura,
  setMotivoReabertura,
] =
  useState("");


const [
  reopeningCash,
  setReopeningCash,
] =
  useState(false);

    const [
  movimentoEditando,
  setMovimentoEditando,
] =
  useState<MovimentoCaixa | null>(
    null,
  );


const [
  editDescricao,
  setEditDescricao,
] =
  useState("");


const [
  editValor,
  setEditValor,
] =
  useState("");


const [
  editFormaPagamento,
  setEditFormaPagamento,
] =
  useState<FormaPagamentoFinanceiro>(
    "pix",
  );


const [
  editingMovement,
  setEditingMovement,
] =
  useState(false);


const [
  estornandoId,
  setEstornandoId,
] =
  useState<string | null>(
    null,
  );

    const [
  fechamentos,
  setFechamentos,
] =
  useState<
    FechamentoCaixa[]
  >([]);


const [
  fechamentoAberto,
  setFechamentoAberto,
] =
  useState<string | null>(
    null,
  );


  const [
    dataFim,
    setDataFim,
  ] =
    useState(
      todayISO(),
    );

    const [
  fechamentoOpen,
  setFechamentoOpen,
] =
  useState(false);


const [
  fechamento,
  setFechamento,
] =
  useState<FechamentoCaixa | null>(
    null,
  );


const [
  closingCash,
  setClosingCash,
] =
  useState(false);


const [
  conferidoPix,
  setConferidoPix,
] =
  useState("");


const [
  conferidoDinheiro,
  setConferidoDinheiro,
] =
  useState("");


const [
  conferidoDebito,
  setConferidoDebito,
] =
  useState("");


const [
  conferidoCredito,
  setConferidoCredito,
] =
  useState("");


const [
  observacaoFechamento,
  setObservacaoFechamento,
] =
  useState("");


  const [
    movimentos,
    setMovimentos,
  ] =
    useState<
      MovimentoCaixa[]
    >([]);


  const [
    loading,
    setLoading,
  ] =
    useState(true);


  const [
    error,
    setError,
  ] =
    useState("");


  const [
    success,
    setSuccess,
  ] =
    useState("");


  const [
    modalOpen,
    setModalOpen,
  ] =
    useState(false);


  const [
    saving,
    setSaving,
  ] =
    useState(false);


  const [
    tipo,
    setTipo,
  ] =
    useState<TipoMovimento>(
      "saida",
    );


  const [
    descricao,
    setDescricao,
  ] =
    useState("");


  const [
    valor,
    setValor,
  ] =
    useState("");


  const [
    formaPagamento,
    setFormaPagamento,
  ] =
    useState<
      FormaPagamentoFinanceiro | null
    >("pix");


  const [
    dataMovimento,
    setDataMovimento,
  ] =
    useState(
      todayISO(),
    );


  async function load() {
    try {
      setLoading(
        true,
      );

      setError("");

      const periodoAnterior =
  previousEquivalentRange(
    dataInicio,
    dataFim,
  );

const [
  movimentosResult,
  fechamentosResult,
  movimentosMesAnteriorResult,
] =
  await Promise.all([
    loadMovimentosPeriodo(
      dataInicio,
      dataFim,
    ),

    loadFechamentosPeriodo(
      dataInicio,
      dataFim,
    ),

    loadMovimentosPeriodo(
      periodoAnterior.inicio,
      periodoAnterior.fim,
    ),
  ]);


setMovimentos(
  movimentosResult,
);

setFechamentos(
  fechamentosResult,
);

setMovimentosMesAnterior(
  movimentosMesAnteriorResult,
);

    } catch (err) {
      console.error(
        err,
      );

      setError(
        err instanceof Error
          ? err.message
          : "Não foi possível carregar o financeiro.",
      );
    } finally {
      setLoading(
        false,
      );
    }
  }


  useEffect(() => {
    load();
  }, [
    dataInicio,
    dataFim,
  ]);


  const resumo =
    useMemo(
      () =>
        calcularResumoFinanceiro(
          movimentos,
        ),
      [
        movimentos,
      ],
    );

    const resumoOrigem =
  useMemo(
    () =>
      calcularResumoPorOrigem(
        movimentos,
      ),
    [
      movimentos,
    ],
  );


  function openModal(
    novoTipo:
      TipoMovimento,
  ) {
    setTipo(
      novoTipo,
    );

    setDescricao("");

    setValor("");

    setFormaPagamento(
      novoTipo ===
        "entrada"
        ? "pix"
        : "dinheiro",
    );

    setDataMovimento(
      todayISO(),
    );

    setError("");

    setSuccess("");

    setModalOpen(
      true,
    );
  }


  function closeModal() {
    if (saving) {
      return;
    }


    setModalOpen(
      false,
    );
  }


  async function handleSave() {
    const numericValue =
      Number(
        valor.replace(
          ",",
          ".",
        ),
      );


    if (
      descricao.trim() ===
      ""
    ) {
      setError(
        "Informe uma descrição.",
      );

      return;
    }


    if (
      Number.isNaN(
        numericValue,
      ) ||
      numericValue <= 0
    ) {
      setError(
        "Informe um valor maior que zero.",
      );

      return;
    }


    try {
      setSaving(
        true,
      );

      setError("");

      setSuccess("");


      await criarMovimentoManual({
        tipo,

        descricao:
          descricao.trim(),

        valor:
          numericValue,

        formaPagamento,

        data:
          dataMovimento,
      });


      setModalOpen(
        false,
      );


      setSuccess(
        tipo === "entrada"
          ? "Entrada registrada com sucesso."
          : "Despesa registrada com sucesso.",
      );


      await load();
    } catch (err) {
      console.error(
        err,
      );

      const message =
  err &&
  typeof err === "object" &&
  "message" in err
    ? String(
        err.message,
      )
    : "Não foi possível registrar o movimento.";


setError(
  message,
);
    } finally {
      setSaving(
        false,
      );
    }
  }

function openFechamento() {
  if (
    dataInicio !== dataFim
  ) {
    setError(
      "Selecione um único dia para fechar o caixa.",
    );

    return;
  }


  const dataSelecionada =
    dataInicio;


  const movimentosDoDia =
    movimentos.filter(
      (movimento) =>
        movimento.data ===
        dataSelecionada,
    );


  const entradasPix =
    movimentosDoDia
      .filter(
        (movimento) =>
          movimento.tipo ===
            "entrada" &&
          movimento.forma_pagamento ===
            "pix",
      )
      .reduce(
        (
          total,
          movimento,
        ) =>
          total +
          Number(
            movimento.valor,
          ),
        0,
      );


  const entradasDinheiro =
    movimentosDoDia
      .filter(
        (movimento) =>
          movimento.tipo ===
            "entrada" &&
          movimento.forma_pagamento ===
            "dinheiro",
      )
      .reduce(
        (
          total,
          movimento,
        ) =>
          total +
          Number(
            movimento.valor,
          ),
        0,
      );


  const entradasDebito =
    movimentosDoDia
      .filter(
        (movimento) =>
          movimento.tipo ===
            "entrada" &&
          movimento.forma_pagamento ===
            "debito",
      )
      .reduce(
        (
          total,
          movimento,
        ) =>
          total +
          Number(
            movimento.valor,
          ),
        0,
      );


  const entradasCredito =
    movimentosDoDia
      .filter(
        (movimento) =>
          movimento.tipo ===
            "entrada" &&
          movimento.forma_pagamento ===
            "credito",
      )
      .reduce(
        (
          total,
          movimento,
        ) =>
          total +
          Number(
            movimento.valor,
          ),
        0,
      );


  setConferidoPix(
    String(
      entradasPix,
    ),
  );

  setConferidoDinheiro(
    String(
      entradasDinheiro,
    ),
  );

  setConferidoDebito(
    String(
      entradasDebito,
    ),
  );

  setConferidoCredito(
    String(
      entradasCredito,
    ),
  );

  setObservacaoFechamento("");

  setError("");

  setSuccess("");

  setFechamentoOpen(
    true,
  );
}


async function handleFecharCaixa() {
  if (
    dataInicio !== dataFim
  ) {
    setError(
      "Selecione um único dia para fechar o caixa.",
    );

    return;
  }


  const dataSelecionada =
    dataInicio;


  const pix =
    Number(
      conferidoPix.replace(
        ",",
        ".",
      ),
    );

  const dinheiro =
    Number(
      conferidoDinheiro.replace(
        ",",
        ".",
      ),
    );

  const debito =
    Number(
      conferidoDebito.replace(
        ",",
        ".",
      ),
    );

  const credito =
    Number(
      conferidoCredito.replace(
        ",",
        ".",
      ),
    );


  const valores = [
    pix,
    dinheiro,
    debito,
    credito,
  ];


  if (
    valores.some(
      (value) =>
        Number.isNaN(
          value,
        ) ||
        value < 0,
    )
  ) {
    setError(
      "Informe valores válidos para a conferência.",
    );

    return;
  }


  try {
    setClosingCash(
      true,
    );

    setError("");

    setSuccess("");


    const result =
      await fecharCaixaDia({
        data:
          dataSelecionada,

        conferidoPix:
          pix,

        conferidoDinheiro:
          dinheiro,

        conferidoDebito:
          debito,

        conferidoCredito:
          credito,

        observacao:
          observacaoFechamento,
      });


    setFechamento(
      result,
    );

    setFechamentoOpen(
      false,
    );

    setSuccess(
      result.diferenca_total ===
        0
        ? "Caixa fechado sem diferenças."
        : "Caixa fechado com diferença de conferência.",
    );

    await load();

  } catch (err) {
    console.error(
      err,
    );

    setError(
      err instanceof Error
        ? err.message
        : "Não foi possível fechar o caixa.",
    );
  } finally {
    setClosingCash(
      false,
    );
  }
}

function podeGerenciarMovimento(
  movimento:
    MovimentoCaixa,
) {
  const manual =
    movimento.origem ===
      "entrada_manual" ||
    movimento.origem ===
      "despesa_manual";


  if (!manual) {
    return false;
  }


  const jaFoiEstornado =
    movimentos.some(
      (item) =>
        item.origem ===
          "estorno_manual" &&
        item.origem_id ===
          movimento.id,
    );


  if (jaFoiEstornado) {
    return false;
  }


  const caixaFechado =
    fechamentos.some(
      (item) =>
        item.data ===
          movimento.data &&
        item.status ===
          "fechado",
    );


  return !caixaFechado;
}

function openEditarMovimento(
  movimento:
    MovimentoCaixa,
) {
  setMovimentoEditando(
    movimento,
  );

  setEditDescricao(
    movimento.descricao,
  );

  setEditValor(
    String(
      movimento.valor,
    ),
  );

  setEditFormaPagamento(
    movimento.forma_pagamento ??
      "pix",
  );

  setError("");

  setSuccess("");
}


function closeEditarMovimento() {
  if (
    editingMovement
  ) {
    return;
  }


  setMovimentoEditando(
    null,
  );
}


async function handleEditarMovimento() {
  if (
    !movimentoEditando
  ) {
    return;
  }


  const numericValue =
    Number(
      editValor.replace(
        ",",
        ".",
      ),
    );


  if (
    editDescricao.trim() ===
    ""
  ) {
    setError(
      "Informe uma descrição.",
    );

    return;
  }


  if (
    Number.isNaN(
      numericValue,
    ) ||
    numericValue <= 0
  ) {
    setError(
      "Informe um valor maior que zero.",
    );

    return;
  }


  try {
    setEditingMovement(
      true,
    );

    setError("");

    setSuccess("");


    await editarMovimentoManual({
      id:
        movimentoEditando.id,

      descricao:
        editDescricao.trim(),

      valor:
        numericValue,

      formaPagamento:
        editFormaPagamento,
    });


    setMovimentoEditando(
      null,
    );

    setSuccess(
      "Lançamento atualizado com sucesso.",
    );


    await load();
  } catch (err) {
    console.error(
      err,
    );

    setError(
      err instanceof Error
        ? err.message
        : "Não foi possível editar o lançamento.",
    );
  } finally {
    setEditingMovement(
      false,
    );
  }
}


async function handleEstornarMovimento(
  movimento:
    MovimentoCaixa,
) {
  const confirmar =
    window.confirm(
      `Deseja realmente estornar "${movimento.descricao}" no valor de ${formatBRL(
        movimento.valor,
      )}?`,
    );


  if (!confirmar) {
    return;
  }


  try {
    setEstornandoId(
      movimento.id,
    );

    setError("");

    setSuccess("");


    await estornarMovimentoManual(
      movimento.id,
    );


    setSuccess(
      "Lançamento estornado com sucesso.",
    );


    await load();
  } catch (err) {
    console.error(
      err,
    );

    setError(
      err instanceof Error
        ? err.message
        : "Não foi possível estornar o lançamento.",
    );
  } finally {
    setEstornandoId(
      null,
    );
  }
}

function openReabrirCaixa(
  fechamento:
    FechamentoCaixa,
) {
  setFechamentoReabrindo(
    fechamento,
  );

  setMotivoReabertura("");

  setError("");

  setSuccess("");
}


function closeReabrirCaixa() {
  if (reopeningCash) {
    return;
  }

  setFechamentoReabrindo(
    null,
  );
}


async function handleReabrirCaixa() {
  if (
    !fechamentoReabrindo
  ) {
    return;
  }


  if (
    motivoReabertura.trim() ===
    ""
  ) {
    setError(
      "Informe o motivo da reabertura.",
    );

    return;
  }


  try {
    setReopeningCash(
      true,
    );

    setError("");

    setSuccess("");


    await reabrirCaixaDia(
      fechamentoReabrindo.data,
      motivoReabertura.trim(),
    );


    setFechamentoReabrindo(
      null,
    );

    setSuccess(
      "Caixa reaberto com sucesso.",
    );


    await load();
  } catch (err) {
    console.error(
      err,
    );

    setError(
      err instanceof Error
        ? err.message
        : "Não foi possível reabrir o caixa.",
    );
  } finally {
    setReopeningCash(
      false,
    );
  }
}

const periodoFechamentoValido =
  dataInicio === dataFim;


const dataFechamentoSelecionada =
  periodoFechamentoValido
    ? dataInicio
    : null;


const movimentosFechamento =
  useMemo(
    () =>
      dataFechamentoSelecionada
        ? movimentos.filter(
            (movimento) =>
              movimento.data ===
              dataFechamentoSelecionada,
          )
        : [],
    [
      movimentos,
      dataFechamentoSelecionada,
    ],
  );


const resumoFechamento =
  useMemo(
    () =>
      calcularResumoFinanceiro(
        movimentosFechamento,
      ),
    [
      movimentosFechamento,
    ],
  );

  const resumoMesAnterior =
  useMemo(
    () =>
      calcularResumoFinanceiro(
        movimentosMesAnterior,
      ),
    [
      movimentosMesAnterior,
    ],
  );

  const resumoOrigemPeriodoAnterior =
  useMemo(
    () =>
      calcularResumoPorOrigem(
        movimentosMesAnterior,
      ),
    [
      movimentosMesAnterior,
    ],
  );


const fechamentoSelecionado =
  useMemo(
    () =>
      dataFechamentoSelecionada
        ? fechamentos.find(
            (item) =>
              item.data ===
              dataFechamentoSelecionada,
          ) ?? null
        : null,
    [
      fechamentos,
      dataFechamentoSelecionada,
    ],
  );

  const resumoDiario =
  useMemo(() => {
    const porDia = new Map<
      string,
      {
        entradas: number;
        saidas: number;
      }
    >();

    for (const movimento of movimentos) {
      const atual =
        porDia.get(
          movimento.data,
        ) ?? {
          entradas: 0,
          saidas: 0,
        };

      if (
        movimento.tipo ===
        "entrada"
      ) {
        atual.entradas +=
          Number(
            movimento.valor,
          );
      } else {
        atual.saidas +=
          Number(
            movimento.valor,
          );
      }

      porDia.set(
        movimento.data,
        atual,
      );
    }

    return Array.from(
      porDia.entries(),
    )
      .map(
        ([
          data,
          valores,
        ]) => ({
          data,
          entradas:
            valores.entradas,
          saidas:
            valores.saidas,
        }),
      )
      .sort(
        (a, b) =>
          a.data.localeCompare(
            b.data,
          ),
      );
  }, [
    movimentos,
  ]);

  const maiorValorDiario =
  useMemo(() => {
    return Math.max(
      1,
      ...resumoDiario.flatMap(
        (item) => [
          item.entradas,
          item.saidas,
        ],
      ),
    );
  }, [
    resumoDiario,
  ]);

  function calcularVariacaoPercentual(
  atual: number,
  anterior: number,
) {
  if (anterior === 0) {
    if (atual === 0) {
      return 0;
    }

    return null;
  }

   return (
    ((atual - anterior) /
      Math.abs(anterior)) *
    100
  );
}

const variacaoEntradas =
  calcularVariacaoPercentual(
    resumo.entradas,
    resumoMesAnterior.entradas,
  );

const variacaoSaidas =
  calcularVariacaoPercentual(
    resumo.saidas,
    resumoMesAnterior.saidas,
  );

const variacaoSaldo =
  calcularVariacaoPercentual(
    resumo.saldo,
    resumoMesAnterior.saldo,
  );

  const variacaoComandas =
  calcularVariacaoPercentual(
    resumoOrigem.comandas,
    resumoOrigemPeriodoAnterior.comandas,
  );

const variacaoQuadras =
  calcularVariacaoPercentual(
    resumoOrigem.quadras,
    resumoOrigemPeriodoAnterior.quadras,
  );

const variacaoPacotes =
  calcularVariacaoPercentual(
    resumoOrigem.pacotes,
    resumoOrigemPeriodoAnterior.pacotes,
  );

const variacaoAulas =
  calcularVariacaoPercentual(
    resumoOrigem.aulasAvulsas,
    resumoOrigemPeriodoAnterior.aulasAvulsas,
  );

const variacaoEntradasManuais =
  calcularVariacaoPercentual(
    resumoOrigem.entradasManuais,
    resumoOrigemPeriodoAnterior.entradasManuais,
  );

const variacaoDespesasManuais =
  calcularVariacaoPercentual(
    resumoOrigem.despesasManuais,
    resumoOrigemPeriodoAnterior.despesasManuais,
  );

  function startOfWeekISO() {
  const now =
    new Date();

  const day =
    now.getDay();

  const diff =
    day === 0
      ? -6
      : 1 - day;

  const monday =
    new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + diff,
    );

  const year =
    monday.getFullYear();

  const month =
    String(
      monday.getMonth() + 1,
    ).padStart(
      2,
      "0",
    );

  const date =
    String(
      monday.getDate(),
    ).padStart(
      2,
      "0",
    );

  return `${year}-${month}-${date}`;
}


function previousMonthRange() {
  const now =
    new Date();

  const firstDay =
    new Date(
      now.getFullYear(),
      now.getMonth() - 1,
      1,
    );

  const lastDay =
    new Date(
      now.getFullYear(),
      now.getMonth(),
      0,
    );


  function toISO(
    value: Date,
  ) {
    const year =
      value.getFullYear();

    const month =
      String(
        value.getMonth() + 1,
      ).padStart(
        2,
        "0",
      );

    const day =
      String(
        value.getDate(),
      ).padStart(
        2,
        "0",
      );

    return `${year}-${month}-${day}`;
  }


  return {
    inicio:
      toISO(
        firstDay,
      ),

    fim:
      toISO(
        lastDay,
      ),
  };
}

  return (
    <section className="financeiro-page">
      <div className="financeiro-header">
        <div>
          <span className="financeiro-eyebrow">
            FINANCEIRO
          </span>

          <h2>
            Fluxo de caixa
          </h2>

          <p>
            Acompanhe entradas, despesas e saldo da arena.
          </p>
        </div>


        <div className="financeiro-header-actions">

            <button
  type="button"
  className="financeiro-secondary-button"
  onClick={() =>
    setRelatorioOpen(
      true,
    )
  }
>
  Gerar relatório
</button>

          <button
            type="button"
            className="financeiro-secondary-button"
            onClick={() =>
              openModal(
                "entrada",
              )
            }
          >
            + Nova entrada
          </button>

          <button
            type="button"
            className="financeiro-primary-button"
            onClick={() =>
              openModal(
                "saida",
              )
            }
          >
            + Nova despesa
          </button>
        </div>
      </div>


      <div className="financeiro-filters">
        <label>
          De

          <input
            type="date"
            value={
              dataInicio
            }
            onChange={(
              event,
            ) =>
              setDataInicio(
                event.target
                  .value,
              )
            }
          />
        </label>

        <label>
          Até

          <input
            type="date"
            value={
              dataFim
            }
            onChange={(
              event,
            ) =>
              setDataFim(
                event.target
                  .value,
              )
            }
          />
        </label>

        <button
          type="button"
          onClick={() => {
            const today =
              todayISO();

            setDataInicio(
              today,
            );

            setDataFim(
              today,
            );
          }}
        >
          Hoje
        </button>

        <button
  type="button"
  onClick={() => {
    setDataInicio(
      startOfWeekISO(),
    );

    setDataFim(
      todayISO(),
    );
  }}
>
  Esta semana
</button>

<button
  type="button"
  onClick={() => {
    const periodo =
      previousMonthRange();

    setDataInicio(
      periodo.inicio,
    );

    setDataFim(
      periodo.fim,
    );
  }}
>
  Mês anterior
</button>

        <button
          type="button"
          onClick={() => {
            setDataInicio(
              firstDayOfMonthISO(),
            );

            setDataFim(
              todayISO(),
            );
          }}
        >
          Este mês
        </button>
      </div>


      <div className="financeiro-summary">
        <div className="financeiro-summary-card">
          <span>
            Entradas
          </span>

          <strong className="financeiro-value-positive">
            {formatBRL(
              resumo.entradas,
            )}
          </strong>
        </div>

        <div className="financeiro-summary-card">
          <span>
            Saídas
          </span>

          <strong className="financeiro-value-negative">
            {formatBRL(
              resumo.saidas,
            )}
          </strong>
        </div>

        <div className="financeiro-summary-card">
          <span>
            Saldo
          </span>

          <strong
            className={
              resumo.saldo >=
              0
                ? "financeiro-value-positive"
                : "financeiro-value-negative"
            }
          >
            {formatBRL(
              resumo.saldo,
            )}
          </strong>
        </div>
      </div>

      <div className="financeiro-comparison">
  <div className="financeiro-comparison-header">
    <div>
      <span className="financeiro-eyebrow">
        COMPARAÇÃO
      </span>

      <h3>
  Período atual x período anterior
</h3>
    </div>

    <span>
  {formatDateBR(
    previousEquivalentRange(
      dataInicio,
      dataFim,
    ).inicio,
  )}
  {" até "}
  {formatDateBR(
    previousEquivalentRange(
      dataInicio,
      dataFim,
    ).fim,
  )}
</span>
  </div>

  <div className="financeiro-comparison-grid">
    <div>
      <span>
        Entradas
      </span>

      <strong>
        {formatBRL(
          resumo.entradas,
        )}
      </strong>

      <small
        className={
          variacaoEntradas ===
            null
            ? ""
            : variacaoEntradas >=
                0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoEntradas ===
        null
          ? "Sem base de comparação"
          : `${variacaoEntradas >= 0 ? "+" : ""}${variacaoEntradas.toFixed(
              1,
            )}%`}
      </small>
    </div>

    

    <div>
      <span>
        Saídas
      </span>

      <strong>
        {formatBRL(
          resumo.saidas,
        )}
      </strong>

      <small
        className={
          variacaoSaidas ===
            null
            ? ""
            : variacaoSaidas <=
                0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoSaidas ===
        null
          ? "Sem base de comparação"
          : `${variacaoSaidas >= 0 ? "+" : ""}${variacaoSaidas.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Saldo
      </span>

      <strong>
        {formatBRL(
          resumo.saldo,
        )}
      </strong>

      <small
        className={
          variacaoSaldo ===
            null
            ? ""
            : variacaoSaldo >=
                0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoSaldo ===
        null
          ? "Sem base de comparação"
          : `${variacaoSaldo >= 0 ? "+" : ""}${variacaoSaldo.toFixed(
              1,
            )}%`}
      </small>
    </div>
  </div>
  <div className="financeiro-comparison-origin">
  <div className="financeiro-comparison-origin-header">
    <span>
      Comparação por origem
    </span>

    <small>
      Período atual x anterior
    </small>
  </div>

  <div className="financeiro-comparison-origin-grid">
    <div>
      <span>
        Comandas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.comandas,
        )}
      </strong>

      <small
        className={
          variacaoComandas === null
            ? ""
            : variacaoComandas >= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoComandas === null
          ? "Sem base"
          : `${variacaoComandas >= 0 ? "+" : ""}${variacaoComandas.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Quadras
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.quadras,
        )}
      </strong>

      <small
        className={
          variacaoQuadras === null
            ? ""
            : variacaoQuadras >= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoQuadras === null
          ? "Sem base"
          : `${variacaoQuadras >= 0 ? "+" : ""}${variacaoQuadras.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Pacotes de aulas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.pacotes,
        )}
      </strong>

      <small
        className={
          variacaoPacotes === null
            ? ""
            : variacaoPacotes >= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoPacotes === null
          ? "Sem base"
          : `${variacaoPacotes >= 0 ? "+" : ""}${variacaoPacotes.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Aulas avulsas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.aulasAvulsas,
        )}
      </strong>

      <small
        className={
          variacaoAulas === null
            ? ""
            : variacaoAulas >= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoAulas === null
          ? "Sem base"
          : `${variacaoAulas >= 0 ? "+" : ""}${variacaoAulas.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Entradas manuais
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.entradasManuais,
        )}
      </strong>

      <small
        className={
          variacaoEntradasManuais === null
            ? ""
            : variacaoEntradasManuais >= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoEntradasManuais === null
          ? "Sem base"
          : `${variacaoEntradasManuais >= 0 ? "+" : ""}${variacaoEntradasManuais.toFixed(
              1,
            )}%`}
      </small>
    </div>

    <div>
      <span>
        Despesas manuais
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.despesasManuais,
        )}
      </strong>

      <small
        className={
          variacaoDespesasManuais === null
            ? ""
            : variacaoDespesasManuais <= 0
              ? "financeiro-comparison-positive"
              : "financeiro-comparison-negative"
        }
      >
        {variacaoDespesasManuais === null
          ? "Sem base"
          : `${variacaoDespesasManuais >= 0 ? "+" : ""}${variacaoDespesasManuais.toFixed(
              1,
            )}%`}
      </small>
    </div>
  </div>
</div>
</div>

<div className="financeiro-chart-card">
  <div className="financeiro-chart-header">
    <div>
      <span className="financeiro-eyebrow">
        EVOLUÇÃO
      </span>

      <h3>
        Entradas x saídas por dia
      </h3>
    </div>

    <div className="financeiro-chart-legend">
      <span>
        <i className="financeiro-chart-dot financeiro-chart-dot-entry" />
        Entradas
      </span>

      <span>
        <i className="financeiro-chart-dot financeiro-chart-dot-exit" />
        Saídas
      </span>
    </div>
  </div>

  {resumoDiario.length ===
  0 ? (
    <div className="financeiro-empty">
      Sem dados para o período selecionado.
    </div>
  ) : (
    <div className="financeiro-chart">
      {resumoDiario.map(
        (item) => (
          <div
            key={
              item.data
            }
            className="financeiro-chart-column"
          >
            <div className="financeiro-chart-bars">
              <div
                className="financeiro-chart-bar financeiro-chart-bar-entry"
                style={{
                  height: `${Math.max(
                    4,
                    (item.entradas /
                      maiorValorDiario) *
                      100,
                  )}%`,
                }}
                title={`Entradas: ${formatBRL(
                  item.entradas,
                )}`}
              />

              <div
                className="financeiro-chart-bar financeiro-chart-bar-exit"
                style={{
                  height: `${Math.max(
                    4,
                    (item.saidas /
                      maiorValorDiario) *
                      100,
                  )}%`,
                }}
                title={`Saídas: ${formatBRL(
                  item.saidas,
                )}`}
              />
            </div>

            <span className="financeiro-chart-date">
              {formatDateBR(
                item.data,
              ).slice(
                0,
                5,
              )}
            </span>
          </div>
        ),
      )}
    </div>
  )}
</div>

      <div className="financeiro-payment-summary">
        <div>
          <span>
            Pix
          </span>

          <strong>
            {formatBRL(
              resumo.pix,
            )}
          </strong>
        </div>

        <div>
          <span>
            Dinheiro
          </span>

          <strong>
            {formatBRL(
              resumo.dinheiro,
            )}
          </strong>
        </div>

        <div>
          <span>
            Débito
          </span>

          <strong>
            {formatBRL(
              resumo.debito,
            )}
          </strong>
        </div>

        <div>
          <span>
            Crédito
          </span>

          <strong>
            {formatBRL(
              resumo.credito,
            )}
          </strong>
        </div>
      </div>

      <div className="financeiro-origin-card">
  <div className="financeiro-origin-header">
    <div>
      <span className="financeiro-eyebrow">
        ORIGEM
      </span>

      <h3>
        Resultado por origem
      </h3>
    </div>

    <span>
      Período selecionado
    </span>
  </div>


  <div className="financeiro-origin-grid">
    <div>
      <span>
        Comandas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.comandas,
        )}
      </strong>
    </div>

    <div>
      <span>
        Quadras
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.quadras,
        )}
      </strong>
    </div>

    <div>
      <span>
        Pacotes de aulas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.pacotes,
        )}
      </strong>
    </div>

    <div>
      <span>
        Aulas avulsas
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.aulasAvulsas,
        )}
      </strong>
    </div>

    <div>
      <span>
        Entradas manuais
      </span>

      <strong>
        {formatBRL(
          resumoOrigem.entradasManuais,
        )}
      </strong>
    </div>

    <div>
      <span>
        Despesas manuais
      </span>

      <strong className="financeiro-value-negative">
        {formatBRL(
          resumoOrigem.despesasManuais,
        )}
      </strong>
    </div>
  </div>
</div>

<div className="financeiro-closing-card">
  <div className="financeiro-closing-header">
    <div>
      <span className="financeiro-eyebrow">
        FECHAMENTO
      </span>

      <h3>
        {dataFechamentoSelecionada
          ? `Caixa de ${formatDateBR(
              dataFechamentoSelecionada,
            )}`
          : "Fechamento de caixa"}
      </h3>

      <p>
        {dataFechamentoSelecionada
          ? "Confira os recebimentos do dia selecionado antes de encerrar o caixa."
          : "Selecione um único dia no filtro para fechar o caixa."}
      </p>
    </div>

    {!periodoFechamentoValido ? (
  <button
    type="button"
    className="financeiro-secondary-button"
    disabled
  >
    Selecione um único dia
  </button>
) : fechamentoSelecionado?.status ===
"fechado" ? (
  <button
    type="button"
    className="financeiro-secondary-button"
    disabled
  >
    Caixa fechado
  </button>
) : (
  <button
    type="button"
    className="financeiro-primary-button"
    onClick={
      openFechamento
    }
  >
    {fechamentoSelecionado?.status ===
    "reaberto"
      ? "Fechar caixa novamente"
      : "Fechar caixa do dia"}
  </button>
)}
  </div>


  <div className="financeiro-closing-preview">
    <div>
      <span>
        Entradas
      </span>

      <strong>
        {formatBRL(
          resumoFechamento.entradas,
        )}
      </strong>
    </div>

    <div>
      <span>
        Saídas
      </span>

      <strong>
        {formatBRL(
          resumoFechamento.saidas,
        )}
      </strong>
    </div>

    <div>
      <span>
        Resultado
      </span>

      <strong>
        {formatBRL(
          resumoFechamento.saldo,
        )}
      </strong>
    </div>
  </div>


  {fechamentoSelecionado && (
    <div className="financeiro-closing-result">
      <strong>
        Fechamento do dia:
      </strong>

      <span>
        Esperado{" "}
        {formatBRL(
          fechamentoSelecionado.esperado_total,
        )}
        {" • "}
        Conferido{" "}
        {formatBRL(
          fechamentoSelecionado.conferido_total,
        )}
        {" • "}
        Diferença{" "}
        {formatBRL(
          fechamentoSelecionado.diferenca_total,
        )}
      </span>
    </div>
  )}
</div>

<div className="financeiro-history-card">
  <div className="financeiro-table-header">
    <div>
      <span className="financeiro-eyebrow">
        FECHAMENTOS
      </span>

      <h3>
        Histórico de caixas
      </h3>
    </div>

    <strong>
      {fechamentos.length}
    </strong>
  </div>


  {fechamentos.length ===
  0 ? (
    <div className="financeiro-empty">
      Nenhum caixa fechado neste período.
    </div>
  ) : (
    <div className="financeiro-closing-history">
      {fechamentos.map(
        (item) => {
          const aberto =
            fechamentoAberto ===
            item.id;


          return (
            <div
              key={
                item.id
              }
              className="financeiro-closing-history-item"
            >
              <button
                type="button"
                className="financeiro-closing-history-summary"
                onClick={() =>
                  setFechamentoAberto(
                    (current) =>
                      current ===
                        item.id
                        ? null
                        : item.id,
                  )
                }
              >
                <div>
                  <strong>
                    {formatDateBR(
                      item.data,
                    )}
                  </strong>

                  <span>
                    {item.diferenca_total ===
                    0
                      ? "Sem diferenças"
                      : "Com diferença"}
                  </span>
                </div>


                <div>
                  <span>
                    Entradas
                  </span>

                  <strong>
                    {formatBRL(
                      item.entradas_total,
                    )}
                  </strong>
                </div>


                <div>
                  <span>
                    Saídas
                  </span>

                  <strong>
                    {formatBRL(
                      item.saidas_total,
                    )}
                  </strong>
                </div>


                <div>
                  <span>
                    Resultado
                  </span>

                  <strong>
                    {formatBRL(
                      item.liquido_total,
                    )}
                  </strong>
                </div>


                <span>
                  {aberto
                    ? "Ocultar"
                    : "Ver detalhes"}
                </span>
              </button>


              {aberto && (
                <div className="financeiro-closing-history-details">
                  <div className="financeiro-closing-detail-grid">
                    <div>
                      <span>
                        Pix esperado
                      </span>

                      <strong>
                        {formatBRL(
                          item.esperado_pix,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Pix conferido
                      </span>

                      <strong>
                        {formatBRL(
                          item.conferido_pix,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Diferença Pix
                      </span>

                      <strong>
                        {formatBRL(
                          item.diferenca_pix,
                        )}
                      </strong>
                    </div>


                    <div>
                      <span>
                        Dinheiro esperado
                      </span>

                      <strong>
                        {formatBRL(
                          item.esperado_dinheiro,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Dinheiro conferido
                      </span>

                      <strong>
                        {formatBRL(
                          item.conferido_dinheiro,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Diferença dinheiro
                      </span>

                      <strong>
                        {formatBRL(
                          item.diferenca_dinheiro,
                        )}
                      </strong>
                    </div>


                    <div>
                      <span>
                        Débito esperado
                      </span>

                      <strong>
                        {formatBRL(
                          item.esperado_debito,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Débito conferido
                      </span>

                      <strong>
                        {formatBRL(
                          item.conferido_debito,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Diferença débito
                      </span>

                      <strong>
                        {formatBRL(
                          item.diferenca_debito,
                        )}
                      </strong>
                    </div>


                    <div>
                      <span>
                        Crédito esperado
                      </span>

                      <strong>
                        {formatBRL(
                          item.esperado_credito,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Crédito conferido
                      </span>

                      <strong>
                        {formatBRL(
                          item.conferido_credito,
                        )}
                      </strong>
                    </div>

                    <div>
                      <span>
                        Diferença crédito
                      </span>

                      <strong>
                        {formatBRL(
                          item.diferenca_credito,
                        )}
                      </strong>
                    </div>
                  </div>


                  <div className="financeiro-closing-total-detail">
                    <span>
                      Esperado total{" "}
                      <strong>
                        {formatBRL(
                          item.esperado_total,
                        )}
                      </strong>
                    </span>

                    <span>
                      Conferido{" "}
                      <strong>
                        {formatBRL(
                          item.conferido_total,
                        )}
                      </strong>
                    </span>

                    <span>
                      Diferença{" "}
                      <strong
                        className={
                          item.diferenca_total ===
                          0
                            ? "financeiro-value-positive"
                            : "financeiro-value-negative"
                        }
                      >
                        {formatBRL(
                          item.diferenca_total,
                        )}
                      </strong>
                    </span>
                  </div>

                  <div className="financeiro-reopen-status">
  <div>
    <span>
      Status do caixa
    </span>

    <strong
      className={
        item.status ===
        "fechado"
          ? "financeiro-status-closed"
          : "financeiro-status-reopened"
      }
    >
      {item.status ===
      "fechado"
        ? "Fechado"
        : "Reaberto"}
    </strong>
  </div>


  {item.status ===
    "reaberto" &&
    item.motivo_reabertura && (
      <div>
        <span>
          Motivo da reabertura
        </span>

        <strong>
          {
            item.motivo_reabertura
          }
        </strong>
      </div>
    )}


  {item.status ===
    "fechado" && (
      <button
        type="button"
        className="financeiro-reopen-button"
        onClick={() =>
          openReabrirCaixa(
            item,
          )
        }
      >
        Reabrir caixa
      </button>
    )}
</div>


                  {item.observacao && (
                    <div className="financeiro-closing-observation">
                      <span>
                        Observação
                      </span>

                      <strong>
                        {item.observacao}
                      </strong>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        },
      )}
    </div>
  )}
</div>


      {success && (
        <div className="financeiro-success">
          {success}
        </div>
      )}


      {error &&
        !modalOpen && (
        <div className="financeiro-error">
          {error}
        </div>
      )}


      <div className="financeiro-table-card">
        <div className="financeiro-table-header">
          <div>
            <span className="financeiro-eyebrow">
              MOVIMENTAÇÕES
            </span>

            <h3>
              Histórico do período
            </h3>
          </div>

          <strong>
            {movimentos.length}
          </strong>
        </div>


        {loading ? (
          <div className="financeiro-empty">
            Carregando movimentações...
          </div>
        ) : movimentos.length ===
          0 ? (
          <div className="financeiro-empty">
            <strong>
              Nenhum movimento encontrado.
            </strong>

            <span>
              Ajuste o período ou registre uma movimentação.
            </span>
          </div>
        ) : (
          <div className="financeiro-table">
            <div className="financeiro-table-row financeiro-table-head">
              <span>
                Data
              </span>

              <span>
                Descrição
              </span>

              <span>
                Origem
              </span>

              <span>
                Pagamento
              </span>

              <span>
                Tipo
              </span>

              <span>
                Valor
              </span>

              <span>
  Ações
</span>
            </div>


            {movimentos.map(
              (
                movimento,
              ) => (
                <div
                  key={
                    movimento.id
                  }
                  className="financeiro-table-row"
                >
                  <span>
                    {formatDateBR(
                      movimento.data,
                    )}
                  </span>

                  <strong>
                    {
                      movimento.descricao
                    }
                  </strong>

                  <span>
                    {formatOrigem(
                      movimento.origem,
                    )}
                  </span>

                  <span>
                    {formatFormaPagamento(
                      movimento.forma_pagamento,
                    )}
                  </span>

                  <span
                    className={
                      movimento.tipo ===
                      "entrada"
                        ? "financeiro-badge financeiro-badge-entry"
                        : "financeiro-badge financeiro-badge-exit"
                    }
                  >
                    {movimento.tipo ===
                    "entrada"
                      ? "Entrada"
                      : "Saída"}
                  </span>

                  <strong
                    className={
                      movimento.tipo ===
                      "entrada"
                        ? "financeiro-value-positive"
                        : "financeiro-value-negative"
                    }
                  >
                    {movimento.tipo ===
                    "entrada"
                      ? "+"
                      : "-"}
                    {formatBRL(
                      movimento.valor,
                    )}
                  </strong>
                  <div className="financeiro-table-actions">
  {podeGerenciarMovimento(
    movimento,
  ) ? (
    <>
      <button
        type="button"
        onClick={() =>
          openEditarMovimento(
            movimento,
          )
        }
      >
        Editar
      </button>

      <button
        type="button"
        className="financeiro-action-danger"
        onClick={() =>
          handleEstornarMovimento(
            movimento,
          )
        }
        disabled={
          estornandoId ===
          movimento.id
        }
      >
        {estornandoId ===
        movimento.id
          ? "Estornando..."
          : "Estornar"}
      </button>
    </>
  ) : (
    <span>
      —
    </span>
  )}
</div>
                </div>
              ),
            )}
          </div>
        )}
      </div>


      {modalOpen && (
        <div className="financeiro-modal-backdrop">
          <div className="financeiro-modal">
            <div className="financeiro-modal-header">
              <div>
                <span className="financeiro-eyebrow">
                  {tipo ===
                  "entrada"
                    ? "ENTRADA"
                    : "DESPESA"}
                </span>

                <h3>
                  {tipo ===
                  "entrada"
                    ? "Nova entrada"
                    : "Nova despesa"}
                </h3>
              </div>

              <button
                type="button"
                onClick={
                  closeModal
                }
                disabled={
                  saving
                }
              >
                ×
              </button>
            </div>


            <label className="financeiro-field">
              Descrição

              <input
                type="text"
                value={
                  descricao
                }
                onChange={(
                  event,
                ) =>
                  setDescricao(
                    event.target
                      .value,
                  )
                }
                placeholder={
                  tipo ===
                  "entrada"
                    ? "Ex.: Patrocínio"
                    : "Ex.: Material de limpeza"
                }
              />
            </label>


            <div className="financeiro-form-row">
              <label className="financeiro-field">
                Valor

                <input
                  type="text"
                  inputMode="decimal"
                  value={
                    valor
                  }
                  onChange={(
                    event,
                  ) =>
                    setValor(
                      event.target
                        .value,
                    )
                  }
                  placeholder="Ex.: 150,00"
                />
              </label>

              <label className="financeiro-field">
                Data

                <input
                  type="date"
                  value={
                    dataMovimento
                  }
                  onChange={(
                    event,
                  ) =>
                    setDataMovimento(
                      event.target
                        .value,
                    )
                  }
                />
              </label>
            </div>


            <label className="financeiro-field">
              Forma de pagamento

              <select
                value={
                  formaPagamento ??
                  ""
                }
                onChange={(
                  event,
                ) =>
                  setFormaPagamento(
                    event.target
                      .value as
                      FormaPagamentoFinanceiro,
                  )
                }
              >
                <option value="pix">
                  Pix
                </option>

                <option value="dinheiro">
                  Dinheiro
                </option>

                <option value="debito">
                  Débito
                </option>

                <option value="credito">
                  Crédito
                </option>
              </select>
            </label>


            {error && (
              <div className="financeiro-error">
                {error}
              </div>
            )}


            <div className="financeiro-modal-actions">
              <button
                type="button"
                className="financeiro-cancel-button"
                onClick={
                  closeModal
                }
                disabled={
                  saving
                }
              >
                Cancelar
              </button>

              <button
                type="button"
                className="financeiro-save-button"
                onClick={
                  handleSave
                }
                disabled={
                  saving
                }
              >
                {saving
                  ? "Salvando..."
                  : tipo ===
                      "entrada"
                    ? "Registrar entrada"
                    : "Registrar despesa"}
              </button>
            </div>
          </div>
        </div>
      )}

      {fechamentoOpen && (
  <div className="financeiro-modal-backdrop">
    <div className="financeiro-modal">
      <div className="financeiro-modal-header">
        <div>
          <span className="financeiro-eyebrow">
            FECHAMENTO
          </span>

          <h3>
            {dataFechamentoSelecionada
              ? `Conferir caixa de ${formatDateBR(
                  dataFechamentoSelecionada,
                )}`
              : "Conferir caixa"}
          </h3>
        </div>

        <button
          type="button"
          onClick={() =>
            setFechamentoOpen(
              false,
            )
          }
          disabled={
            closingCash
          }
        >
          ×
        </button>
      </div>


      <div className="financeiro-closing-form-grid">
        <label className="financeiro-field">
          Pix conferido

          <input
            type="text"
            inputMode="decimal"
            value={
              conferidoPix
            }
            onChange={(
              event,
            ) =>
              setConferidoPix(
                event.target
                  .value,
              )
            }
          />
        </label>

        <label className="financeiro-field">
          Dinheiro conferido

          <input
            type="text"
            inputMode="decimal"
            value={
              conferidoDinheiro
            }
            onChange={(
              event,
            ) =>
              setConferidoDinheiro(
                event.target
                  .value,
              )
            }
          />
        </label>

        <label className="financeiro-field">
          Débito conferido

          <input
            type="text"
            inputMode="decimal"
            value={
              conferidoDebito
            }
            onChange={(
              event,
            ) =>
              setConferidoDebito(
                event.target
                  .value,
              )
            }
          />
        </label>

        <label className="financeiro-field">
          Crédito conferido

          <input
            type="text"
            inputMode="decimal"
            value={
              conferidoCredito
            }
            onChange={(
              event,
            ) =>
              setConferidoCredito(
                event.target
                  .value,
              )
            }
          />
        </label>
      </div>


      <label className="financeiro-field">
        Observação

        <input
          type="text"
          value={
            observacaoFechamento
          }
          onChange={(
            event,
          ) =>
            setObservacaoFechamento(
              event.target
                .value,
            )
          }
          placeholder="Opcional"
        />
      </label>


      {error && (
        <div className="financeiro-error">
          {error}
        </div>
      )}


      <div className="financeiro-modal-actions">
        <button
          type="button"
          className="financeiro-cancel-button"
          onClick={() =>
            setFechamentoOpen(
              false,
            )
          }
          disabled={
            closingCash
          }
        >
          Cancelar
        </button>

        <button
          type="button"
          className="financeiro-save-button"
          onClick={
            handleFecharCaixa
          }
          disabled={
            closingCash
          }
        >
          {closingCash
            ? "Fechando..."
            : "Confirmar fechamento"}
        </button>
      </div>
    </div>
  </div>
)}

{movimentoEditando && (
  <div className="financeiro-modal-backdrop">
    <div className="financeiro-modal">
      <div className="financeiro-modal-header">
        <div>
          <span className="financeiro-eyebrow">
            EDIÇÃO
          </span>

          <h3>
            Editar lançamento
          </h3>
        </div>

        <button
          type="button"
          onClick={
            closeEditarMovimento
          }
          disabled={
            editingMovement
          }
        >
          ×
        </button>
      </div>


      <label className="financeiro-field">
        Descrição

        <input
          type="text"
          value={
            editDescricao
          }
          onChange={(
            event,
          ) =>
            setEditDescricao(
              event.target.value,
            )
          }
        />
      </label>


      <div className="financeiro-form-row">
        <label className="financeiro-field">
          Valor

          <input
            type="text"
            inputMode="decimal"
            value={
              editValor
            }
            onChange={(
              event,
            ) =>
              setEditValor(
                event.target.value,
              )
            }
          />
        </label>


        <label className="financeiro-field">
          Forma de pagamento

          <select
            value={
              editFormaPagamento
            }
            onChange={(
              event,
            ) =>
              setEditFormaPagamento(
                event.target.value as
                  FormaPagamentoFinanceiro,
              )
            }
          >
            <option value="pix">
              Pix
            </option>

            <option value="dinheiro">
              Dinheiro
            </option>

            <option value="debito">
              Débito
            </option>

            <option value="credito">
              Crédito
            </option>
          </select>
        </label>
      </div>


      {error && (
        <div className="financeiro-error">
          {error}
        </div>
      )}


      <div className="financeiro-modal-actions">
        <button
          type="button"
          className="financeiro-cancel-button"
          onClick={
            closeEditarMovimento
          }
          disabled={
            editingMovement
          }
        >
          Cancelar
        </button>

        <button
          type="button"
          className="financeiro-save-button"
          onClick={
            handleEditarMovimento
          }
          disabled={
            editingMovement
          }
        >
          {editingMovement
            ? "Salvando..."
            : "Salvar alterações"}
        </button>
      </div>
    </div>
  </div>
)}

{fechamentoReabrindo && (
  <div className="financeiro-modal-backdrop">
    <div className="financeiro-modal">
      <div className="financeiro-modal-header">
        <div>
          <span className="financeiro-eyebrow">
            REABERTURA
          </span>

          <h3>
            Reabrir caixa
          </h3>
        </div>

        <button
          type="button"
          onClick={
            closeReabrirCaixa
          }
          disabled={
            reopeningCash
          }
        >
          ×
        </button>
      </div>


      <p className="financeiro-reopen-text">
        Você está reabrindo o caixa de{" "}
        <strong>
          {formatDateBR(
            fechamentoReabrindo.data,
          )}
        </strong>
        .
      </p>


      <label className="financeiro-field">
        Motivo da reabertura

        <input
          type="text"
          value={
            motivoReabertura
          }
          onChange={(
            event,
          ) =>
            setMotivoReabertura(
              event.target.value,
            )
          }
          placeholder="Ex.: lançamento feito com valor incorreto"
        />
      </label>


      {error && (
        <div className="financeiro-error">
          {error}
        </div>
      )}


      <div className="financeiro-modal-actions">
        <button
          type="button"
          className="financeiro-cancel-button"
          onClick={
            closeReabrirCaixa
          }
          disabled={
            reopeningCash
          }
        >
          Cancelar
        </button>

        <button
          type="button"
          className="financeiro-save-button"
          onClick={
            handleReabrirCaixa
          }
          disabled={
            reopeningCash
          }
        >
          {reopeningCash
            ? "Reabrindo..."
            : "Confirmar reabertura"}
        </button>
      </div>
    </div>
  </div>
)}

{relatorioOpen && (
  <div className="financeiro-modal-backdrop">
    <div className="financeiro-report-modal">
      <div className="financeiro-modal-header">
        <div>
          <span className="financeiro-eyebrow">
            RELATÓRIO
          </span>

          <h3>
            Relatório financeiro
          </h3>
        </div>

        <button
          type="button"
          onClick={() =>
            setRelatorioOpen(
              false,
            )
          }
        >
          ×
        </button>
      </div>

      <div className="financeiro-report">
        <div className="financeiro-report-header">
          <div>
            <strong>
              SUNSET ONE
            </strong>

            <span>
              Relatório financeiro
            </span>
          </div>

          <div>
            <span>
              Período
            </span>

            <strong>
              {formatDateBR(
                dataInicio,
              )}
              {" até "}
              {formatDateBR(
                dataFim,
              )}
            </strong>
          </div>
        </div>

        <div className="financeiro-report-summary">
          <div>
            <span>
              Entradas
            </span>

            <strong>
              {formatBRL(
                resumo.entradas,
              )}
            </strong>
          </div>

          <div>
            <span>
              Saídas
            </span>

            <strong>
              {formatBRL(
                resumo.saidas,
              )}
            </strong>
          </div>

          <div>
            <span>
              Saldo
            </span>

            <strong>
              {formatBRL(
                resumo.saldo,
              )}
            </strong>
          </div>
        </div>

        <div className="financeiro-report-section">
          <h4>
            Formas de pagamento
          </h4>

          <div className="financeiro-report-grid">
            <div>
              <span>
                Pix
              </span>

              <strong>
                {formatBRL(
                  resumo.pix,
                )}
              </strong>
            </div>

            <div>
              <span>
                Dinheiro
              </span>

              <strong>
                {formatBRL(
                  resumo.dinheiro,
                )}
              </strong>
            </div>

            <div>
              <span>
                Débito
              </span>

              <strong>
                {formatBRL(
                  resumo.debito,
                )}
              </strong>
            </div>

            <div>
              <span>
                Crédito
              </span>

              <strong>
                {formatBRL(
                  resumo.credito,
                )}
              </strong>
            </div>
          </div>
        </div>

        <div className="financeiro-report-section">
          <h4>
            Resultado por origem
          </h4>

          <div className="financeiro-report-grid">
            <div>
              <span>
                Comandas
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.comandas,
                )}
              </strong>
            </div>

            <div>
              <span>
                Quadras
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.quadras,
                )}
              </strong>
            </div>

            <div>
              <span>
                Pacotes
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.pacotes,
                )}
              </strong>
            </div>

            <div>
              <span>
                Aulas avulsas
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.aulasAvulsas,
                )}
              </strong>
            </div>

            <div>
              <span>
                Entradas manuais
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.entradasManuais,
                )}
              </strong>
            </div>

            <div>
              <span>
                Despesas manuais
              </span>

              <strong>
                {formatBRL(
                  resumoOrigem.despesasManuais,
                )}
              </strong>
            </div>
          </div>
        </div>

        <div className="financeiro-report-section">
          <h4>
            Movimentações
          </h4>

          <div className="financeiro-report-table">
            <div className="financeiro-report-table-head">
              <span>
                Data
              </span>

              <span>
                Descrição
              </span>

              <span>
                Origem
              </span>

              <span>
                Tipo
              </span>

              <span>
                Valor
              </span>
            </div>

            {movimentos.map(
              (
                movimento,
              ) => (
                <div
                  key={
                    movimento.id
                  }
                  className="financeiro-report-table-row"
                >
                  <span>
                    {formatDateBR(
                      movimento.data,
                    )}
                  </span>

                  <span>
                    {
                      movimento.descricao
                    }
                  </span>

                  <span>
                    {formatOrigem(
                      movimento.origem,
                    )}
                  </span>

                  <span>
                    {movimento.tipo ===
                    "entrada"
                      ? "Entrada"
                      : "Saída"}
                  </span>

                  <strong>
                    {movimento.tipo ===
                    "entrada"
                      ? "+"
                      : "-"}
                    {formatBRL(
                      movimento.valor,
                    )}
                  </strong>
                </div>
              ),
            )}
          </div>
        </div>
      </div>

      <div className="financeiro-modal-actions">
        <button
  type="button"
  className="financeiro-primary-button"
  onClick={() =>
    window.print()
  }
>
  Imprimir / Salvar PDF
</button>
        <button
          type="button"
          className="financeiro-cancel-button"
          onClick={() =>
            setRelatorioOpen(
              false,
            )
          }
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
)}
    </section>
  );
}
